import SelectInputTemplate from './SelectInput';

/**
 * A select dropdown component using `react-select`.
 */
const SelectInput = SelectInputTemplate;

export default SelectInput;
